import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx } from "react/jsx-runtime";
//#region src/components/RectanglePortraitStack.tsx
const RectanglePortraitStackIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.673 1.952c.133.008.267.029.4.064l8.694 2.33a2 2 0 0 1 1.414 2.45l-3.107 11.59-.057.183-.004.007-.018.042c-.02.048-.04.096-.062.142l-.02.035a1.975 1.975 0 0 1-.072.129l-.037.055a1.965 1.965 0 0 1-.072.102l-.05.062a1.923 1.923 0 0 1-.421.381c-.024.016-.047.032-.072.047a2.057 2.057 0 0 1-.256.134l-.077.03a2.05 2.05 0 0 1-.094.034l-.096.028c-.027.007-.053.015-.08.021-.031.007-.063.012-.094.018-.034.006-.067.012-.101.016-.018.003-.035.003-.052.005a1.938 1.938 0 0 1-.139.01h-.044c-.046 0-.093.001-.14-.002a2.02 2.02 0 0 1-.19-.021l-.201-.043-.632-.17a1.998 1.998 0 0 1-1.789 1.857l-.204.01H5a2.007 2.007 0 0 1-1.414-.585A2.005 2.005 0 0 1 3 19.499v-12a2.031 2.031 0 0 1 .241-.954A2 2 0 0 1 5 5.499h4.07l.553-2.069a2.001 2.001 0 0 1 2.05-1.478ZM5 7.499v12h8.95l.047-.003.003-.045V7.499H5ZM16 17.56l1.106.298.035.008.015-.047L20.25 6.28l-8.693-2.33h-.002l-.415 1.55H14a2 2 0 0 1 2 2V17.56Z",
		fill: props.fill || "currentColor"
	})
}));
//#endregion
export { RectanglePortraitStackIcon };
